export type VisibilityRegistryPage = {
  id: string;
  label: string;
  sections: { id: string; label: string }[];
};

export const visibilityRegistry: VisibilityRegistryPage[] = [
  {
    id: "global-features",
    label: "Global Features",
    sections: [
      { id: "chat-jci", label: "ChatJCI Widget" },
      { id: "chat-jci-page", label: "ChatJCI Page" },
    ],
  },
  {
    id: "navigation",
    label: "Navigation Menu",
    sections: [
      { id: "overview", label: "Overview (Dashboard)" },
      { id: "youth-futures", label: "Youth Futures (Dropdown)" },
      { id: "youth-futures-impact-metrics", label: "├─ Impact Metrics" },
      { id: "youth-futures-mental-health", label: "├─ Mental Health" },
      { id: "youth-futures-workforce", label: "├─ Workforce & Education" },
      { id: "youth-futures-entrepreneurship", label: "└─ Entrepreneurship" },
      { id: "database", label: "Database (Dropdown)" },
      { id: "database-member-insights", label: "├─ Member Insights" },
      { id: "database-programs-events", label: "├─ Programs & Events" },
      { id: "database-technology", label: "├─ Technology & Future" },
      { id: "database-regional", label: "└─ Regional Analysis" },
      { id: "vision-2040-nav", label: "Vision 2040" },
      { id: "know-more", label: "Know More (Dropdown)" },
      { id: "know-more-methodology", label: "├─ Methodology" },
      { id: "know-more-development-councils", label: "├─ Development Councils" },
      { id: "know-more-contributing", label: "├─ Contributing" },
      { id: "know-more-faq", label: "└─ FAQ" },
    ],
  },
  {
    id: "dashboard",
    label: "Dashboard",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "personalized-focus", label: "Personalized Focus Widget" },
      { id: "what-is-fii", label: "What is FII" },
      { id: "member-experience", label: "Member Experience" },
      { id: "vision-2040", label: "Vision 2040 Hero" },
      { id: "global-presence", label: "Global Presence Map" },
      { id: "quick-navigation", label: "Quick Navigation Cards" },
    ],
  },
  {
    id: "index",
    label: "Homepage",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "vision-2040-hero", label: "Vision 2040 Hero" },
      { id: "overview", label: "Global Impact Overview" },
      { id: "digital-reach", label: "Digital Reach" },
      { id: "member-demographics", label: "Member Demographics" },
      { id: "regional-analysis", label: "Regional Analysis" },
      { id: "member-insights", label: "Member Insights Section" },
      { id: "programs-events", label: "Programs & Events Section" },
      { id: "technology-future", label: "Technology & Future Section" },
      { id: "impact-metrics", label: "Impact & Metrics Section" },
    ],
  },
  {
    id: "mental-health-dimension",
    label: "Mental Health Dimension",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "crisis-stats", label: "Crisis Statistics" },
      { id: "fii-indicators", label: "FII Indicators" },
      { id: "regional-scores", label: "Regional Scores" },
      { id: "rise-programs", label: "JCI RISE Programs" },
      { id: "regional-distribution", label: "Regional Distribution" },
      { id: "outcomes-measured", label: "Outcomes Measured" },
      { id: "actions", label: "Action Cards" },
      { id: "data-sources", label: "Data Sources" },
    ],
  },
  {
    id: "workforce-education",
    label: "Workforce & Education",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "crisis-stats", label: "Crisis Statistics" },
      { id: "fii-indicators", label: "FII Indicators" },
      { id: "regional-scores", label: "Regional Scores" },
      { id: "skills-gap", label: "Skills Gap Analysis" },
      { id: "regional-deep-dives", label: "Regional Deep Dives" },
      { id: "jci-initiatives", label: "JCI Initiatives" },
      { id: "case-studies", label: "Case Studies" },
      { id: "actions", label: "Recommended Actions" },
      { id: "data-sources", label: "Data Sources" },
    ],
  },
  {
    id: "entrepreneurship-support",
    label: "Entrepreneurship Support",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "opportunity-stats", label: "Opportunity Statistics" },
      { id: "fii-indicators", label: "FII Indicators" },
      { id: "regional-scores", label: "Regional Scores" },
      { id: "financing-gap", label: "Financing Gap" },
      { id: "regional-deep-dives", label: "Regional Deep Dives" },
      { id: "case-studies", label: "Case Studies" },
      { id: "actions", label: "Recommended Actions" },
      { id: "data-sources", label: "Data Sources" },
    ],
  },
  {
    id: "member-insights",
    label: "Member Insights",
    sections: [
      { id: "member-experience-dashboard", label: "Member Experience Dashboard" },
      { id: "skills-development-dashboard", label: "Skills Development Dashboard" },
      { id: "member-profile", label: "Member Profile" },
      { id: "jci-foundation-grants", label: "JCI Foundation Grants" },
      { id: "jci-senate-recognition", label: "JCI Senate Recognition" },
      { id: "member-motivations", label: "Member Motivations" },
    ],
  },
  {
    id: "programs-events",
    label: "Programs & Events",
    sections: [
      { id: "flagship-programs", label: "Flagship Programs" },
      { id: "rise-pillar-dashboard", label: "JCI RISE Pillar Dashboard" },
      { id: "human-duties-initiative", label: "Human Duties Initiative" },
      { id: "sdg-alignment-matrix", label: "SDG Alignment Matrix" },
      { id: "resource-mobilization", label: "Resource Mobilization" },
      { id: "event-outcomes", label: "Event Outcomes" },
      { id: "conferences-map", label: "Conferences Map" },
      { id: "strategic-partnerships", label: "Strategic Partnerships" },
    ],
  },
  {
    id: "regional-analysis",
    label: "Regional Analysis",
    sections: [
      { id: "regional-distribution", label: "Regional Distribution" },
      { id: "interactive-map", label: "Interactive Map" },
    ],
  },
  {
    id: "technology-future",
    label: "Technology & Future",
    sections: [
      { id: "digital-ecosystem-dashboard", label: "Digital Ecosystem Dashboard" },
      { id: "global-trends", label: "Global Trends" },
      { id: "future-skills", label: "Future Skills" },
    ],
  },
  {
    id: "impact-metrics",
    label: "Impact & Metrics",
    sections: [
      { id: "fii-formula-explainer", label: "FII Formula Explainer" },
      { id: "fii-rankings-table", label: "FII Rankings Table" },
      { id: "global-fii-map", label: "Global FII Map" },
      { id: "regional-fii-analysis", label: "Regional FII Analysis" },
      { id: "fii-insights", label: "FII Insights" },
      { id: "fii-methodology", label: "FII Methodology" },
      { id: "fii-call-to-action", label: "FII Call to Action" },
    ],
  },
  {
    id: "vision-2040",
    label: "Vision 2040",
    sections: [
      { id: "growth-visualization", label: "Growth Visualization" },
      { id: "strategic-pillars", label: "Strategic Pillars" },
      { id: "milestone-tracker", label: "Milestone Tracker" },
      { id: "fii-impact-tab", label: "FII Impact Tab" },
      { id: "timeline-tab", label: "Timeline Tab" },
      { id: "simulator-tab", label: "Simulator Tab" },
      { id: "global-view-tab", label: "Global View Tab" },
      { id: "tech-roadmap", label: "Technology Roadmap" },
    ],
  },
  {
    id: "methodology",
    label: "Methodology",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "overview", label: "Overview" },
      { id: "five-phases", label: "5-Phase Framework" },
      { id: "data-sources", label: "Data Sources" },
      { id: "dc-partnership", label: "DC Partnership Role" },
      { id: "data-collection", label: "Data Collection Methodology" },
      { id: "data-standards", label: "Data Standards" },
      { id: "validation-process", label: "Validation Process" },
      { id: "governance-structure", label: "Governance Structure Proposal" },
      { id: "vision-2040-alignment", label: "Vision 2040 Alignment" },
      { id: "transparency", label: "Transparency & Reproducibility" },
      { id: "expansion-roadmap", label: "Expansion Roadmap" },
      { id: "summary-status", label: "Summary Status" },
      { id: "methodology-faq", label: "Methodology FAQ" },
      { id: "cta", label: "Call to Action" },
    ],
  },
  {
    id: "faq",
    label: "FAQ",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "what-is", label: "What Is Observatory" },
      { id: "development-councils", label: "Development Councils" },
      { id: "methodology", label: "DASHCity Methodology" },
      { id: "data-standards", label: "Data Standards" },
      { id: "areas-opportunity", label: "Areas of Opportunity" },
      { id: "roadmap", label: "Future Roadmap" },
      { id: "technical-faqs", label: "Technical FAQs" },
      { id: "contact", label: "Contact" },
      { id: "cta", label: "Call to Action" },
    ],
  },
{ 
    id: "contributing", 
    label: "Contributing", 
    sections: [
      { id: "hero", label: "Hero" },
      { id: "why-contribute", label: "Why Contribute" },
      { id: "who-can-contribute", label: "Who Can Contribute" },
      { id: "process", label: "Contribution Process" },
      { id: "commitments", label: "Our Commitments" },
      { id: "contribution-types", label: "Contribution Types" },
      { id: "faq", label: "FAQ" },
      { id: "team", label: "Our Team" },
      { id: "cta", label: "Call to Action" },
    ] 
  },
  {
    id: "development-councils",
    label: "Development Councils",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "overview", label: "Overview" },
      { id: "council-adc", label: "ADC Details" },
      { id: "council-edc", label: "EDC Details" },
      { id: "council-amdec", label: "AMDEC Details" },
      { id: "council-apdc", label: "APDC Details" },
      { id: "comparative-analysis", label: "Comparative Analysis" },
      { id: "metrics-dashboard", label: "Key Metrics" },
      { id: "highlights", label: "2025 Highlights" },
    ],
  },
{ 
    id: "settings", 
    label: "User Dashboard", 
    sections: [
      { id: "header", label: "Header" },
      { id: "profile", label: "Profile Card" },
      { id: "sign-in-prompt", label: "Sign In Prompt" },
      { id: "observatory-lens", label: "Observatory Lens" },
      { id: "observatory-progress", label: "Observatory Progress" },
      { id: "appearance", label: "Appearance" },
      { id: "language", label: "Language" },
      { id: "analytics", label: "Analytics Preferences" },
      { id: "notifications", label: "Notification Preferences" },
      { id: "admin-tools", label: "Admin Tools" },
      { id: "api-keys", label: "API Key Management" },
      { id: "data-admin", label: "Data Administration" },
      { id: "api-analytics", label: "API Analytics Dashboard" },
      { id: "privacy-data", label: "Privacy & Data" },
      { id: "danger-zone", label: "Danger Zone" },
    ]
  },
  {
    id: "privacy",
    label: "Privacy Policy",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "introduction", label: "Introduction" },
      { id: "controller", label: "Data Controller" },
      { id: "data-collection", label: "Data Collection" },
      { id: "usage", label: "Data Usage" },
      { id: "legal-basis", label: "Legal Basis" },
      { id: "cookies", label: "Cookies" },
      { id: "third-party", label: "Third Party Services" },
      { id: "retention", label: "Data Retention" },
      { id: "rights", label: "Your Rights" },
      { id: "international", label: "International Compliance" },
      { id: "children", label: "Children's Privacy" },
      { id: "security", label: "Security" },
      { id: "transfers", label: "International Transfers" },
      { id: "changes", label: "Policy Changes" },
      { id: "contact", label: "Contact" },
    ]
  },
  {
    id: "terms",
    label: "Terms of Service",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "introduction", label: "Introduction" },
      { id: "eligibility", label: "Eligibility" },
      { id: "account", label: "Account Responsibilities" },
      { id: "acceptable-use", label: "Acceptable Use" },
      { id: "intellectual-property", label: "Intellectual Property" },
      { id: "data-privacy", label: "Data Privacy" },
      { id: "third-party", label: "Third Party Services" },
      { id: "disclaimers", label: "Disclaimers" },
      { id: "responsibilities", label: "Your Responsibilities" },
      { id: "governing-law", label: "Governing Law" },
      { id: "termination", label: "Termination" },
      { id: "contact", label: "Contact" },
    ]
  },
  {
    id: "country-profile",
    label: "Country Profile",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "demographics", label: "Demographics" },
      { id: "jci-presence", label: "JCI Presence" },
      { id: "dimensions", label: "Dimension Analysis" },
      { id: "violence-safety", label: "Violence & Safety" },
      { id: "organizational-health", label: "Organizational Health" },
      { id: "swot-analysis", label: "Member SWOT Analysis" },
      { id: "geographic-gap", label: "Geographic Distribution" },
      { id: "training-insights", label: "Training Participation" },
      { id: "sdg-preferences", label: "SDG Member Priorities" },
      { id: "programs", label: "Key Programs" },
      { id: "sdg", label: "SDG Alignment" },
      { id: "recommendations", label: "Strategic Recommendations" },
      { id: "data-sources", label: "Research Sources" },
    ]
  },
  {
    id: "api-docs",
    label: "API Documentation",
    sections: [
      { id: "hero", label: "Hero" },
      { id: "features", label: "Key Features" },
      { id: "authentication", label: "Authentication Guide" },
      { id: "endpoints", label: "Endpoints Overview" },
      { id: "response-format", label: "Response Format" },
      { id: "error-handling", label: "Error Handling" },
      { id: "use-cases", label: "Use Cases" },
      { id: "quick-start", label: "Quick Start" },
      { id: "cta", label: "Call to Action" },
    ],
  },
];
